import { gql } from '@apollo/client';

export const CREATE_RESOURCE = gql`
  mutation CreateResource($input: CreateResourceRequest!) {
    createResource(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        uri
        thumbnail_uri
        name
        type
        tags
        categories
        size
        source
        description
        file_extension
        alias
        allow_download
        transcoding_status
        created
        modified
      }
    }
  }
`;

export const UPDATE_RESOURCE = gql`
  mutation UpdateResource($input: UpdateResourceRequest!) {
    updateResource(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        uri
        thumbnail_uri
        name
        type
        tags
        categories
        size
        source
        description
        file_extension
        alias
        allow_download
        transcoding_status
        created
        modified
      }
    }
  }
`;

export const SOFT_DELETE_RESOURCE = gql`
  mutation SoftDeleteResource($input: SoftDeleteResourceRequest!) {
    softDeleteResource(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;

export const RESTORE_RESOURCE = gql`
  mutation RestoreResource($input: RestoreResourceRequest!) {
    restoreResource(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;

export const HARD_DELETE_RESOURCE = gql`
  mutation HardDeleteResource($input: HardDeleteResourceRequest!) {
    hardDeleteResource(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
      }
    }
  }
`;
